import AnimatedCheck from './AnimatedCheck';

export default AnimatedCheck;
